import React, { Component, Fragment } from 'react';

import { Link } from 'react-router-dom';
import { get } from "../../../server/actions";
import { getActiveSchoolYearSettings } from '../ManageSchools/manageSchoolSettings';
import { getModuleEnum, getAccessLevelByModule, getPOSSessionActiveStatus } from '../../../server/util'
import logo from '../../../assets/img/mealManageLogo.PNG';
import PropTypes from 'prop-types'
import { access_token, CATERER_WEB_URL } from '../../../server/constants';
let loginUserInfo = {}
class schoolAdminHeader extends Component {
    componentWillMount = () => {
        console.log('this', this.context.router.history)
        loginUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));

        get('/mealSchools/' + sessionStorage.getItem('SchoolId') + '?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let stripeInfo = { 'isPaymentEnabled': data.isPaymentEnabled, 'stripeAccountId': data.stripeAccountId };
            this.setState({ schoolName: data.schoolName, schoolLogo: data.logoLink, stripeInfo: stripeInfo });
        })
            .catch(
                (error) => {
                    console.log('Get school logo response', error)
                }
            )

        this.getSchoolYearSettings();
    }

    getSchoolYearSettings = () => {
        getActiveSchoolYearSettings(sessionStorage.getItem('SchoolId'))
            .then((schoolYearSettings) => {
                this.setState({ enableTempRecertReminder: schoolYearSettings.enableTempRecertReminder === true });
            })
            .catch(
                (error) => {
                    console.log('Get school year settings response', error)
                }
            )
    }
    onLogoutClick = () => {
        console.log('this', this.context.router.history)
        let request = new Promise((resolve) => (get('/logout?access_token=').then(response => {
            console.log('resp', response);
            if (!response.ok || response.ok) {
                resolve(sessionStorage.clear());
            }
        })));

        Promise.resolve(request).then(() => {
            console.log('this', this.context.router.history);
            //this.context.router.history.push({pathname: '/login'});
            window.location.replace('/login');// redirect to login
        });

    }
    prepareCatererUrl = () => {
        const refresh_token = sessionStorage.getItem('refresh_token') || '';
        const schoolId = sessionStorage.getItem('SchoolId');
        const _src = `${btoa(`akey=${access_token()}&rkey=${refresh_token}&sid=${schoolId}`)}`;

        return `${CATERER_WEB_URL}/?${_src}`
    }

    constructor() {
        super()
        this.state = {
            schoolName: '',
            schoolLogo: '',
            stripeInfo: {},
            enableTempRecertReminder: false
        }
    }

    render() {
        const modEnum = getModuleEnum();

        return (
            <header id="pageTop" className="header-wrapper">
                <div className="container-fluid color-bar top-fixed clearfix">
                    <div className="row">
                        <div className="col-sm-1 col-xs-2 bg-color-1">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-2">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-3">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-4">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-5">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-6">fix bar</div>
                        <div className="col-sm-1 bg-color-1 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-2 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-3 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-4 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-5 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-6 hidden-xs">fix bar</div>
                    </div>
                </div>
                <nav id="menuBar" className="navbar navbar-default lightHeader">
                    <div className="container">
                        <div className="navbar-header" style={{ position: 'relative' }}>
                            <button type="button" className="navbar-toggle" data-toggle="collapse"
                                data-target="#navbar">
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                            </button>
                            <Link className="navbar-brand school-admin-brand" id="brand" to="/schoolAdmin"><img
                                className="admin-logo" src={this.state.schoolLogo ? this.state.schoolLogo : logo}
                                alt="" />
                                <div className="school-name">
                                    <span>{this.state.schoolName}</span>
                                </div>
                            </Link>
                        </div>
                        <div className="navbar-collapse collapse" id="navbar">
                            <ul className="nav navbar-nav navbar-right" style={{ height: 'auto' }}>
                                <li className=" dropdown color-5 active">
                                    <Link to="/schoolAdmin" role="button" aria-haspopup="true" aria-expanded="false"><i
                                        className="fa fa-home bg-color-1" aria-hidden="true" /> <span>Home</span></Link>
                                    {/*<ul className="dropdown-menu dropdown-menu-right">*/}
                                    {/*<li className=" " ><Link to="/superAdmin/schoolList"><i className="fa fa-magic"/>  Onboard - New School</Link></li></ul>*/}
                                </li>

                                <li className=" dropdown megaDropMenu color-2 ">
                                    <a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown"
                                        data-hover="dropdown" aria-haspopup="true" data-delay="300"
                                        data-close-others="true" aria-expanded="false">
                                        <i className="fa fa-server bg-color-2" aria-hidden="true"></i>
                                        <span>Manage</span>
                                    </a>
                                    <ul className="row dropdown-menu">
                                        {getAccessLevelByModule(modEnum.SIU) || getAccessLevelByModule(modEnum.SM) || getAccessLevelByModule(modEnum.LETM) || getAccessLevelByModule(modEnum.SSISI) || getAccessLevelByModule(modEnum.BACP) ?
                                            <li className="col-sm-2 col-xs-6" >
                                                {getAccessLevelByModule(modEnum.SIU) || getAccessLevelByModule(modEnum.SM) || getAccessLevelByModule(modEnum.LETM) || getAccessLevelByModule(modEnum.SSISI) ?
                                                    <ul className="list-unstyled">
                                                        <li>School</li>
                                                        {(getAccessLevelByModule(modEnum.SIU) || getAccessLevelByModule(modEnum.SSISI)) ?
                                                            <li className=""><Link to="/schoolAdmin/setupSchool">Import Students</Link>
                                                            </li> : null
                                                        }
                                                        {getAccessLevelByModule(modEnum.SM) ?
                                                            <li className=""><Link to="/schoolAdmin/studentLookUp">Student Lookup</Link>
                                                            </li> : null
                                                        }
                                                        {getAccessLevelByModule(modEnum.SM) ?
                                                            <li className=""><Link to="/schoolAdmin/manageSchool">Manage Students</Link>
                                                            </li> : null
                                                        }
                                                    </ul> : null
                                                }
                                                {getAccessLevelByModule(modEnum.BACP) ?
                                                    <ul className="list-unstyled">
                                                        <li>Child Care</li>
                                                        {
                                                            getAccessLevelByModule(modEnum.BACP) ?
                                                                <li className=""><Link to="/schoolAdmin/enrollmentSummary">Manage BC & AC</Link>
                                                                </li> : null
                                                        }
                                                    </ul>
                                                    : null
                                                }
                                            </li> : null
                                        }
                                        {getAccessLevelByModule(modEnum.LETM) || getAccessLevelByModule(modEnum.LETM) || getAccessLevelByModule(modEnum.MPAE) || getAccessLevelByModule(modEnum.ESEA) ?
                                            <li className='col-sm-2 col-xs-6'>
                                                {getAccessLevelByModule(modEnum.LETM) || getAccessLevelByModule(modEnum.LETM) ?
                                                    <ul className="list-unstyled">
                                                        <li>Eligibility</li>
                                                        {
                                                            getAccessLevelByModule(modEnum.LETM) ?
                                                                <li className=""><Link to="/schoolAdmin/schoolMealProgram">Manage Application</Link>
                                                                </li> : null
                                                        }
                                                        {
                                                            getAccessLevelByModule(modEnum.LETM) ?
                                                                <li className=""><Link to="/schoolAdmin/importCertificationData">Direct Certification Import</Link>
                                                                </li> : null
                                                        }
                                                        {
                                                            getAccessLevelByModule(modEnum.ESEA) ?
                                                                <li><Link to="/schoolAdmin/eseaFormList">ESEA Form</Link></li> : null
                                                        }
                                                    </ul> : null
                                                }
                                                {getAccessLevelByModule(modEnum.MPAE) ?
                                                    <ul className="list-unstyled">
                                                        <li>Events</li>
                                                        {
                                                            getAccessLevelByModule(modEnum.MPAE) ?
                                                                <li className=""><Link to="/schoolAdmin/events">Manage Events</Link>
                                                                </li> : null
                                                        }
                                                    </ul>
                                                    : null
                                                }
                                            </li> : null
                                        }
                                        {
                                            getAccessLevelByModule(modEnum.LMCU) || getAccessLevelByModule(modEnum.LMCI) ||
                                                getAccessLevelByModule(modEnum.BMCU) || getAccessLevelByModule(modEnum.BMCI) ?
                                                <li className="col-sm-2 col-xs-6">
                                                    <ul className="list-unstyled">
                                                        <li>Menu</li>
                                                        {/* {
                                                            getAccessLevelByModule(modEnum.LMCU) || getAccessLevelByModule(modEnum.BMCU) ?
                                                                <li className=""><Link to="/schoolAdmin/createMenu">Create Menu</Link></li> : null
                                                        } */}
                                                        {
                                                            (sessionStorage.getItem('ROLE') == 'ROLE_ADMIN') ? null : <li className=""><Link to="/schoolAdmin/createMenu">Create Menu</Link></li>
                                                        }
                                                        {
                                                            getAccessLevelByModule(modEnum.LMCU) || getAccessLevelByModule(modEnum.LMCU) ?
                                                                <li className=""><Link to="/schoolAdmin/viewMenu">View Menu's</Link></li> : null
                                                        }
                                                        {
                                                            getAccessLevelByModule(modEnum.LMCU) || getAccessLevelByModule(modEnum.LMCU) ?
                                                                <li className=""><Link to="/schoolAdmin/menuManage">Menu Management</Link></li> : null
                                                        }
                                                        <li className=''><Link to="/schoolAdmin/lunchSessions" > Lunch Session</Link></li>
                                                        <li className=""><a href={this.prepareCatererUrl()} target="_blank">Go To Caterer Dashboard</a></li>

                                                    </ul>
                                                </li> : null
                                        }
                                        {

                                            <li className="col-sm-2 col-xs-6">
                                                <ul className="list-unstyled">
                                                    <li>Orders</li>

                                                    <li className=""><Link to="/schoolAdmin/viewOrdersGrid">View/Manage Orders </Link></li>
                                                    {/*  { getAccessLevelByModule(modEnum.CEPS) && <li className=""><Link to="/schoolAdmin/bulkOrdersGrid">Bulk Orders </Link></li>} */}

                                                    <li className=""><Link to="/schoolAdmin/viewReports">Quick Reports</Link></li>
                                                    {/* <li className=""><Link to="/schoolAdmin/adminReports">Admin Reports</Link></li> */}
                                                </ul>
                                            </li>
                                        }

                                        {
                                            getAccessLevelByModule(modEnum.APCC) || getAccessLevelByModule(modEnum.APO) || getAccessLevelByModule(modEnum.CEPS) ?
                                                <li className="col-sm-2 col-xs-6">
                                                    <ul className="list-unstyled">
                                                        <li>Reports</li>

                                                        <li className=""><Link to="/schoolAdmin/mealReport">Meal Reports</Link></li>
                                                        <li className=""><Link to={{
                                                            pathname: '/schoolAdmin/financialReport',
                                                            state: { stripeReport: this.state.stripeInfo }
                                                        }}>Financial Reports</Link></li>
                                                        {(getAccessLevelByModule(modEnum.LETM) || getAccessLevelByModule(modEnum.CEPS)) && <li className=""><Link to="/schoolAdmin/claimReport">Claims Reports</Link></li>}
                                                    </ul>
                                                </li> : null
                                        }
                                        {
                                            getAccessLevelByModule(modEnum.APCC) || getAccessLevelByModule(modEnum.APO) || getAccessLevelByModule(modEnum.CEPS) ?
                                                <li className="col-sm-2 col-xs-6">
                                                    <ul className="list-unstyled">
                                                        <li>Payments</li>
                                                        {
                                                            getAccessLevelByModule(modEnum.APCC) ?
                                                                <Fragment><li className=""><Link to="/schoolAdmin/managePayments">Add Payments</Link></li>
                                                                    <li className=""><Link to="/schoolAdmin/manageLunchBalance">Import/Export Account Balance</Link></li>
                                                                </Fragment>
                                                                : null}
                                                        {/* <li className=""><Link to="/schoolAdmin/paymentReports">Transaction Reports</Link></li> */}
                                                        <li className=""><Link to="/schoolAdmin/addTransaction">Add Transaction</Link></li>
                                                        {getAccessLevelByModule(modEnum.CEPS) && <li className=""><Link to="/schoolAdmin/bulkTransaction">Bulk Transactions</Link></li>}
                                                        {getPOSSessionActiveStatus() && <li className=""><Link to="/schoolAdmin/dailyPosCash">Daily POS Cash Approval</Link></li>}
                                                    </ul>
                                                </li> : null
                                        }
                                    </ul>
                                </li>

                                {loginUserInfo.isPrimaryAdmin ? (
                                    <li className="dropdown singleDrop color-6">
                                        <a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown"
                                            role="button" aria-haspopup="true" aria-expanded="false"><i
                                                className="fa fa-sliders bg-color-4" aria-hidden="true" /> <span>Settings</span></a>
                                        <ul className="dropdown-menu dropdown-menu-right">
                                            {
                                                getAccessLevelByModule(modEnum.SSISI) ?
                                                    <li><Link to="/schoolAdmin/datasync"> <i className="fa fa-database" /> Data
                                                        Sync Settings
                                                    </Link></li> : null}
                                            <li><Link to="/schoolAdmin/manageUsers"> <i className="fa fa-user" /> Manage Users
                                            </Link></li>
                                            <li><Link to="/schoolAdmin/lowBalEmail"> <i className="fa fa-bell" /> Low Balance Email Setup
                                            </Link></li>

                                            <li><Link to="/schoolAdmin/manageSchools"> <i className="fa fa-graduation-cap" /> Manage School Year
                                            </Link></li>
                                            {
                                                getAccessLevelByModule(modEnum.BACP) ?
                                                    <li><Link to="/schoolAdmin/managePackage"><i className="fa fa-graduation-cap" /> Manage BC & AC Package</Link></li> :
                                                    null
                                            }
                                            <li><Link to="/schoolAdmin/poslocation"> <i className="fa fa-location-arrow" /> &nbsp; Manage POS Location
                                            </Link></li>
                                            <li><Link to="/schoolAdmin/nutrition"> <i className="fa fa-location-arrow" /> &nbsp; Manage Nutrition Info
                                            </Link></li>
                                            <li>
                                                <Link to="/schoolAdmin/broadcastMessage" ><i
                                                    className="fa fa-envelope" aria-hidden="true" />&nbsp; Broadcast Message</Link>
                                            </li>
                                             { 
                                               getAccessLevelByModule(modEnum.LETM) ? <li>
                                                <Link to="/schoolAdmin/eligibilityCodeSettings" ><i
                                                    className="fa fa-database" aria-hidden="true" />&nbsp; Eligibility Code Settings</Link>  
                                            </li> : null}
                                            { 
                                            getAccessLevelByModule(modEnum.LETM) ? <li>
                                                <Link to="/schoolAdmin/directCertificationSettings" ><i
                                                    className="fa fa-database" aria-hidden="true" />&nbsp; Direct Certification Settings</Link>  
                                            </li> : null}
                                           {
                                                getAccessLevelByModule(modEnum.LETM) ? <li>
                                                <Link to="/schoolAdmin/editEligibilityLetter" ><i
                                                    className="fa fa-cogs" aria-hidden="true" />&nbsp; Edit Eligibility Letter</Link>
                                            </li> : null}
                                            {
                                                getAccessLevelByModule(modEnum.LETM) && this.state.enableTempRecertReminder ? <li>
                                                <Link to="/schoolAdmin/notSubmittedNotification" ><i
                                                    className="fa fa-bell" aria-hidden="true" />&nbsp; Not Submitted Notification</Link>
                                            </li> : null}
                                        </ul>
                                    </li>) : null}

                                <li className="dropdown singleDrop color-6">
                                    <a href="javascript:void(0)" className="dropdown-toggle" data-toggle="dropdown"
                                        role="button" aria-haspopup="true" aria-expanded="false"><i
                                            className="fa fa-user bg-color-6" aria-hidden="true" /> <span>Account</span></a>
                                    <ul className="dropdown-menu dropdown-menu-right">
                                        <li><Link to="/schoolAdmin/account"> <i className="fa fa-user" /> Profile Details
                                        </Link></li>
                                        <li onClick={this.onLogoutClick.bind(this)}><Link to="/login"> <i
                                            className="fa fa-power-off" /> Logout</Link></li>
                                    </ul>
                                </li>
                                <li className=" dropdown color-5 active">
                                    <Link to="/schoolAdmin/supportRequest" role="button" aria-haspopup="true" aria-expanded="false"><i
                                        className="fa fa-address-card-o bg-color-5" aria-hidden="true" /> <span>Support</span></Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>

        )
    }
}

schoolAdminHeader.contextTypes = {
    router: PropTypes.object.isRequired
}

export default schoolAdminHeader;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/schoolAdminHeader.jsx